export function ProfAIAvatar(props: { size?: number }) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 15,
          alignItems: 'center',
          marginBottom: 3,
        }}
      >
        <img
          alt={`ProfAI Avatar`}
          src="/img/profai.png"
          width={props.size || 96}
          style={{
            borderRadius: '50%',
            backgroundColor: 'var(--colors-marigold)',
          }}
        />
        <span
          style={{
            fontSize: 26,
            fontWeight: 500,
            color: 'var(--colors-warm-90)',
          }}
        >
          Prof<strong>AI</strong>
        </span>
      </div>
    </div>
  );
}
